module.exports = __webpack_public_path__ + "img/10.5102bf1d.png";